export function createSearchIndexerClient(transport) {
    return {
        /**
         * POST /internal/v1/tenants/{tenantId}/indexes/{indexAlias}/events
         *
         * Requires scope: search-indexer:project
         */
        projectSearchEvent(tenantId, indexAlias, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/indexes/${encodeURIComponent(indexAlias)}/events`,
                body,
                options,
            });
        },
        /**
         * GET /internal/v1/tenants/{tenantId}/indexes/{indexAlias}/checkpoints/{source}
         *
         * Requires scope: search-indexer:read
         */
        getProjectionCheckpoint(tenantId, indexAlias, source, options) {
            return transport.request({
                method: "GET",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/indexes/${encodeURIComponent(indexAlias)}/checkpoints/${encodeURIComponent(source)}`,
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/indexes/{indexAlias}/rebuilds
         *
         * Requires scope: search-indexer:rebuild
         */
        rebuildTenantIndex(tenantId, indexAlias, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/indexes/${encodeURIComponent(indexAlias)}/rebuilds`,
                body,
                options,
            });
        },
        /**
         * List every tenant's projection checkpoints, at the table's own grain
         *
         * Requires scope: search-indexer:platform:read
         */
        listPlatformIndexCheckpoints(limit, after, options) {
            return transport.request({
                method: "GET",
                path: "/v1/platform/index-checkpoints",
                query: { limit: limit, after: after },
                options,
            });
        },
        /**
         * List every tenant's index rebuild requests, as an index and a state
         *
         * Requires scope: search-indexer:platform:read
         */
        listPlatformIndexRebuilds(limit, after, options) {
            return transport.request({
                method: "GET",
                path: "/v1/platform/index-rebuilds",
                query: { limit: limit, after: after },
                options,
            });
        },
        /**
         * List every tenant's dead-lettered projection events, oldest arrival first
         *
         * Requires scope: search-indexer:platform:read
         */
        listPlatformIndexDeadLetters(limit, after, options) {
            return transport.request({
                method: "GET",
                path: "/v1/platform/index-dead-letters",
                query: { limit: limit, after: after },
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=search-indexer.js.map